import React, { useState } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";

const CommonAutocomplete = ({
  label,
  options,
  value,
  onChange,
  isDisabled,
  getOptionLabel,
  loading,
  onOpen,
  height = 40,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    if (onOpen) onOpen();
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Autocomplete
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      value={value}
      onChange={(e, newValue) => onChange(newValue)}
      options={loading ? [] : options}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      disabled={isDisabled}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={label}
          InputProps={{
            ...params.InputProps,
            sx: {
              height: `${height}px`,
              paddingRight: "8px",
              display: "flex",
              alignItems: "center",
              padding: "0 !important",
            },
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              height: `${height}px`,
              borderRadius: "0px",
              fontSize: "0.9rem",
              padding: "0 8px",
              display: "flex",
              alignItems: "center",
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#dddddd",
              },
            },
            "& .MuiOutlinedInput-input::placeholder": {
              color: "#495057 !important",
            },
            "& .MuiOutlinedInput-input": {
              padding: "0px 8px !important",
              height: "auto",
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#80bdff",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#dddddd",
            },
          }}
        />
      )}
    />
  );
};

export default CommonAutocomplete;

